
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  
  const units = [
    { name: 'B', size: 1 },
    { name: 'KB', size: 1024 },
    { name: 'MB', size: 1024 * 1024 },
    { name: 'GB', size: 1024 * 1024 * 1024 },
    { name: 'TB', size: 1024 * 1024 * 1024 * 1024 }
  ]

  for (let i = units.length - 1; i >= 0; i--) {
    const unit = units[i]
    if (bytes >= unit.size) {
      const count = bytes / unit.size
      const rounded = Math.round(count * 100) / 100
      const cleanNumber = rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(2)
      return `${cleanNumber} ${unit.name}`
    }
  }
  return `${bytes} B`
}
